import { lazy, Suspense } from 'react'

import { FormBlockerElementCustomizedCardElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

const TouchDataCard = lazy(() =>
  import('@cash-web/account-card-studio-feature-main').then(module => ({ default: module.TouchDataCard }))
)

export const CustomizedCardElement = ({ card_customization }: FormBlockerElementCustomizedCardElement) => {
  return (
    <Suspense fallback={null}>
      <TouchDataCard card_customization={card_customization} />
    </Suspense>
  )
}
